document.addEventListener( 'DOMContentLoaded', function () {
	const layoutButtons = document.querySelectorAll( '.toggle-layout-button' );
	const listWrapper = document.getElementById( 'toggleWrapper' );

	function createHeader() {
		// Remove existing header if it exists
		const existingHeader = listWrapper.querySelector( '.list-header' );
		if ( existingHeader ) {
			existingHeader.remove();
		}
		// Create a new header only for list view
		if ( listWrapper.getAttribute( 'data-layout' ) === 'list' ) {
			const items = listWrapper.querySelectorAll( '.layout-item' );
			const header = document.createElement( 'div' );
			header.className = 'list-header';

			const headerKeys = new Set();
			items.forEach( ( item ) => {
				item.querySelectorAll( '[data-key]' ).forEach( ( subItem ) => {
					console.log( subItem.getAttribute( 'data-key' ) );
					headerKeys.add( subItem.getAttribute( 'data-key' ) );
				} );
			} );

			headerKeys.forEach( ( key ) => {
				const headerItem = document.createElement( 'div' );
				headerItem.className = 'header-item';
				headerItem.textContent = key;
				header.appendChild( headerItem );
			} );
			const listWrapperContainer =
				listWrapper.querySelector( '.layout-container' );
			listWrapperContainer.prepend( header );
		}
	}

	// Listen for clicks on any layout button
	layoutButtons.forEach( ( button ) => {
		button.addEventListener( 'click', function () {
			// Update layout attribute based on the clicked button
			listWrapper.setAttribute(
				'data-layout',
				button.getAttribute( 'data-layout' )
			);
			createHeader(); // Call createHeader to adjust the header based on the current layout

			// Set aria-pressed attribute of the clicked button to true
			button.setAttribute( 'aria-pressed', 'true' );

			// Set aria-pressed attribute of the other buttons to false
			layoutButtons.forEach( ( otherButton ) => {
				if ( otherButton !== button ) {
					otherButton.setAttribute( 'aria-pressed', 'false' );
				}
			} );
		} );
	} );
} );
